import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import * as auth from '../redux/AuthRedux'
import { confirmOtp } from '../redux/AuthCRUD'
import { AlertView, AlertModel } from '../../../../_template/helpers/components/AlertList'
import ResendOTP from './widgets/ResendOTP'

const initialValues = {
  code: '',
}
const confirmOtpSchema = Yup.object().shape({
  code: Yup.string()
    .matches(RegExp('^[0-9]*$'), 'Üye İşyeri Id rakam olmalı')
    .length(6, '6 Char')
    .required('Code is required'),
})

export function ConfirmOtp() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const dispatch = useDispatch()
  const [alerts, setAlerts] = useState<AlertModel[]>([])

  const showAlert = (alert: AlertModel) => {
    setAlerts((prevToasts) => [...prevToasts, alert])
  }

  const formik = useFormik({
    initialValues,
    validationSchema: confirmOtpSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      // showAlert({title: "Error", state:"danger", description: "Clicked Button" })
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        confirmOtp(values.code)
          .then(({ data }) => {
            setHasErrors(false)
            setLoading(false)
            if (data.status) {
              dispatch(auth.actions.otpConfirmed(data.data))
              if (data.data.token_policy == "webuser") {
                dispatch(auth.actions.requestUser())
              }
            } else {
              setHasErrors(true)
              setSubmitting(false)
              setStatus(data.message)
            }
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('Hatalı Kod Girdiniz')
          })
      }, 1000)
    },
  })




  return (
    <>
      <AlertView alerts={alerts} />
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Tek Kullanımlık Parola</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>Telefon numaranıza gelen kodu girin</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              Hatalı Kod Girdiniz
            </div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>Başarılı</div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Tek Kullanımlık Parola</label>
          <input
            type='text'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('code')}
            className={clsx(
              'form-control form-control-lg ',
              { 'is-invalid': formik.touched.code && formik.errors.code },
              {
                'is-valid': formik.touched.code && !formik.errors.code,
              }
            )}
          />
          {formik.touched.code && formik.errors.code && (
            <div className='fv-plugins-message-container invalid-feedback'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.code}</span>
              </div>
            </div>
          )}

          <ResendOTP />
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
            disabled={!formik.isValid}
          >
            {!loading && <span className='indicator-label'>Doğrula</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Bekleyin...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting}
            >
              Geri
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
